import gatangu from "./img/gatangu.png";
import wakawaka from "./img/wakawaka.png";
import corelisstore from "./img/corelisstore.png";
import moranga from "./img/moranga.png";
import honey from "./img/honey.png";
import social from "./img/social.png"

export const products = [
  {
    id: 1,
    img: gatangu,
    link: "https://gatanguenterprises.co.ke/index.html",
    name: "gatangu-ecommerce",
  },
  {
    id: 2,
    img: wakawaka,
    link: "",
    name: "real-estate",
  },
  {
    id: 3,
    img: corelisstore,
    link: "",
    name: "selling clothes{(!hosted)} ",
  },
  {
    id: 4,
    img: moranga,
    link: "",
    name: "milk {!hosted}",
  },
  {
    id: 5,
    img: honey,
    link: "https://thybee.netlify.app",
    name: "Bee products ",
  },
  {
    id: 6,
    img: social,
    link: "",
    name: "Social media App {!hosted}",
  },
];
